export default __webpack_public_path__ + "static/media/vi.4b572212.svg";